import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { ConfirmDialog, Typography } from '@pocketlaw/tetris';
export function ConfirmRemoveEsigningDialog(props) {
    const { onCancel, onSubmit } = props;
    return (<ConfirmDialog appearance="danger" size="sm" title={t({
            comment: 'Cancel eSigning dialog - title',
            message: 'Cancel eSigning',
        })} confirm={t({
            comment: 'Cancel eSigning dialog - confirm button label',
            message: 'Confirm',
        })} cancel={t({
            comment: 'Cancel eSigning dialog - cancel button label',
            message: 'Cancel',
        })} onConfirm={onSubmit} onCancel={onCancel}>
      <Typography>
        <Trans comment="Cancel eSigning dialog - body text">
          The signing parties will no longer be able to sign the document.
        </Trans>
      </Typography>
    </ConfirmDialog>);
}
